import React from 'react';
import { func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockDefault.module.css';
import { FormattedMessage } from 'react-intl';

const FieldMedia = props => {
  const { className, media, sizes, options, blockId, isLandingPage } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      {blockId === 'section-4-block-1' && (
        <div className={css.contentOnImages}>

          <div className={css.lineContainer}>
            <div className={css.line}></div>
            <div className={css.arrow}></div>
          </div>

          <h3 className={css.h3Heading}><FormattedMessage id="LandingPage.HowItWorks"/></h3>
          <h1 className={css.h1Heading}><FormattedMessage id="LandingPage.ForSellers"/></h1>{' '}

          <div className={css.lineContainerVertical}>
            <div className={css.lineVertical}></div>
            <div className={css.arrowDown}></div>
          </div>

        </div>
      )}
      {blockId === 'section-5-block-2' && (
        <div className={css.contentOnImages}>

          <div className={css.lineContainerLeft}>
            <div className={css.arrowLeft}></div>
            <div className={css.lineLeft}></div>
          </div>

          <h3 className={css.h3Heading}><FormattedMessage id="LandingPage.HowItWorks"/></h3>
          <h1 className={css.h1Heading}><FormattedMessage id="LandingPage.ForShoppers"/></h1>{' '}

          <div className={css.lineContainerVertical}>
            <div className={css.lineVertical}></div>
            <div className={css.arrowDown}></div>
          </div>

        </div>
      )}
      <Field
        data={media}
        className={
          blockId === 'section-5-block-2' || blockId === 'section-4-block-1'
            ? css.ImagesOfSellShop
            : ''
        }
        sizes={sizes}
        options={options}
      />
    </div>
  ) : null;
};

const BlockDefault = props => {
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    isLandingPage,
  } = props;
  console.log(blockId, 'blockid');
  const classes = classNames(rootClassName || css.root, className);
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);

  return (
    <BlockContainer id={blockId} className={classes}>
      <FieldMedia
        media={media}
        sizes={responsiveImageSizes}
        className={mediaClassName}
        options={options}
        blockId={blockId}
        isLandingPage={isLandingPage}
      />
      {hasTextComponentFields ? (
        <div
          className={classNames(textClassName, {
            [css.text]: blockId !== 'section-4-block-2' && blockId !== 'section-5-block-1',
            [css.textblock]: blockId === 'section-4-block-2' || blockId === 'section-5-block-1',
          })}
        >
          <Field data={title} options={options} />

          {blockId === 'section-4-block-2' || blockId === 'section-5-block-1' ? (
            <div className={css.fieldContainer}>
              <div className={css.verticalLine}></div>
              <Field data={text} options={options} />
            </div>
          ) : (
            <Field data={text} options={options} />
          )}
          <Field data={callToAction} className={ctaButtonClass} options={options} />
        </div>
      ) : null}
    </BlockContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

BlockDefault.defaultProps = {
  className: null,
  rootClassName: null,
  mediaClassName: null,
  textClassName: null,
  ctaButtonClass: null,
  title: null,
  text: null,
  callToAction: null,
  media: null,
  responsiveImageSizes: null,
  options: null,
};

BlockDefault.propTypes = {
  blockId: string.isRequired,
  className: string,
  rootClassName: string,
  mediaClassName: string,
  textClassName: string,
  ctaButtonClass: string,
  title: object,
  text: object,
  callToAction: object,
  media: object,
  responsiveImageSizes: string,
  options: propTypeOption,
};

export default BlockDefault;
